import {
  Consistancy,
  ReflectionReminder,
  Inactivity,
  GoalUpdate,
  Achievement,
  MilestoneREflection,
  Struggle,
  EmotionalWelness,
  PositiveMomentum,
} from "@utils/defaultImages";

export const achievements = [
  {
    RankImage: Consistancy,
    title: "Consistency",
    subheading: "Logged workouts or meals 3+ days in a row! 🎉",
    description:
      "“You’re on a roll! Keep this rhythm going — consistency is your power.”",
  },
  {
    RankImage: ReflectionReminder,
    title: "Reflection Reminder",
    subheading: "End of the week or cycle reached",
    description:
      "Take a short pause and reflect — what worked best for you this week?",
  },
  {
    RankImage: Inactivity,
    title: "Inactivity",
    subheading: "No progress or activity logged for several days",
    description:
      "It’s been a while since your last update. Restart your journey — small steps count!",
  },
  {
    RankImage: GoalUpdate,
    title: "Goal Update",
    subheading: "Time to review or adjust goals",
    description:
      "Your progress shows improvement! Let’s refresh your goals for the next step.",
  },
  {
    RankImage: Achievement,
    title: "Achievement",
    subheading: "User completes a milestone or goal",
    description:
      "Goal accomplished! Momentum like this keeps you growing — celebrate your win.",
  },
  {
    RankImage: MilestoneREflection,
    title: "Milestone Reflection",
    subheading: "Major milestone achieved",
    description:
      "You’ve reached a milestone! Celebrate your growth and set your next target.",
  },
  {
    RankImage: Struggle,
    title: "Struggle",
    subheading: "Progress dropped or motivation low",
    description:
      "It’s okay to have off days. Reflect, reset, and get back stronger.",
  },
  {
    RankImage: EmotionalWelness,
    title: "Emotional Wellness",
    subheading: "Signs of fatigue, stress, or burnout detected",
    description:
      "Feeling drained? Take a mindful pause — rest is part of progress too.",
  },
  {
    RankImage: PositiveMomentum,
    title: "Positive Momentum",
    subheading: "User maintains a consistent streak",
    description:
      "You’re on fire! Your steady effort this week is inspiring — keep it up!",
  },
];
